import { AnyAction } from "redux";
import { Dispatch } from "react";
import { ProductRaw, Result } from "../../../../interfaces";
import { Remove } from "../../../../controllers/products";
import { Adapter } from "../../../../shared/adapter";
import { ProductAdapter } from "../../../../adapter/products-adapter";

export const FETCH_DELETE_PRODUCTS_REQUEST = 'FETCH_DELETE_PRODUCTS_REQUEST';
export const FETCH_DELETE_PRODUCTS_SUCCESS = 'FETCH_DELETE_PRODUCTS_SUCCESS';
export const FETCH_DELETE_PRODUCTS_FAILURE = 'FETCH_DELETE_PRODUCTS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteProductsRequest = () => {
    return {
        type: FETCH_DELETE_PRODUCTS_REQUEST,
    };
};

const fetchDeleteProductsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_PRODUCTS_SUCCESS,
        payload: data
    };
};

const fetchDeleteProductsFailure = (error: any) => {
    return {
        type: FETCH_DELETE_PRODUCTS_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteProductsRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteProductsSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteProductsFailure(error.message));
        }
    };
};
